import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18b85e86&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=18b85e86&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b85e86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CkLoader: require('/home/vsts/work/1/s/components/Ck/Loader/index.vue').default,CkIcon: require('/home/vsts/work/1/s/components/Ck/Icon/index.js').default})
